export const getAnalyticsDefaults = (brandName: string, breakpointString: string) => ({
  core: {
    stagingEnvironment: process.env.REACT_APP_STAGE?.toUpperCase(),
    dataLayerVersion: '2.8',
    pageInfo: {
      pageName: null,
      intendedCustomerDeviceType: 'all',
      version: 'R1.0',
      releaseDate: '2023-06-01',
      language: 'fr',
      market: 'FR',
      publisher: 'DU',
    },
    category: {
      primaryCategory: 'Leasing',
      secondaryCategory: 'Standalone',
      siteType: 'checkoutSite',
      maturityLevel: 'Online contract',
      contractType: 'New',
      inventoryType: 'Point of Sale',
    },
    attributes: {
      journeyType: 'dealer-facing-product-journey',
      viewChange: null,
      brand: brandName,
    },
  },
  error: {
    errorCode: null,
    errorMessage: null,
    errorCausingURL: null,
  },
  product: [
    {
      category: 'Finance',
      name: 'AutoCredit',
      productAddons: [],
      attributes: {
        typeOfSale: 'Hybrid sales',
        paymentFrequency: null,
        currency: 'EUR',
        recurringPayment: null,
        duration: null,
        durationUnit: null,
        startDateOfContract: null,
        paymentType: null,
        yearlyMileage: null,
        contractMileage: null,
        excessMileage: null,
        mileageUnit: 'KILOMETERS',
        registrationDateOwner: null,
        balloonPayment: null,
        netLoanAmount: null,
        grossLoanAmount: null,
        downPaymentAmount: null,
        nominalInterestRate: null,
        nominalInterestAmount: null,
        effectiveInterestRate: null,
        contractAmount: null,
      },
      vehicleModel: [
        {
          manufacturer: null,
          name: null,
          descriptionLong: null,
          bodyType: null,
          initialRegistrationDate: null,
          currency: null,
          category: null,
          salesID: null,
          basePrice_localCurrency: null,
          manufacturerCode: null,
          endPrice_localCurrency: null,
          typeOfUse: null,
          condition: null,
          engine: {
            fuelType: null,
            emission: null,
            transmission: null,
            enginePower: null,
          },
        },
      ],
    },
  ],
  dealerData: {
    companyId: null,
    companyName: null,
    address: {
      street: null,
      zipCode: null,
      city: null,
    },
  },
  form: {
    type: null,
    name: null,
    errorFields: null,
  },
  design: {
    browserResolutionBreakpoint: breakpointString,
  },
  customerData: {
    loginStatus: null,
    loggedInUserGroup: null,
    yearOfBirth: null,
    gender: null,
    ccResult: null,
    address: {
      zipCode: null,
    },
  },
  dataPrivacyStatement: {
    allowPostalAds: null,
    allowPhoneAds: null,
    allowElectronicAds: null,
    allowMailAds: null,
    allowElectronicInvoices: null,
  },
  eventInfo: [
    {
      eventType: null,
      eventAction: null,
      eventTargetURL: null,
      linkInformation: null,
    },
  ],
  event: null,
});
